module.exports = __webpack_public_path__ + "img/feedback_list1.8db1c0f0.png";